<template>
  <validation-observer ref="FileValidationObserver" v-slot="{ passes }">
    <div class="file-upload__container">
      <div class="row">
        <div
          class="col"
          :class="isProvisionalRemedyArea ? 'col-sm-3' : 'col-sm-4'"
        >
          <span class="file-upload__label">Nombre del Documento:</span>
          <validation-provider
            v-slot="{ errors }"
            class="w-100"
            rules="required"
          >
            <custom-input
              v-model="model.name"
              custom-error-msg="El nombre del documento es requerido."
              :error="errors[0]"
              maxlength="50"
            />
          </validation-provider>
        </div>
        <div
          class="col"
          :class="isProvisionalRemedyArea ? 'col-sm-3' : 'col-sm-4'"
        >
          <validation-provider
            v-slot="{ errors }"
            class="w-100"
            name="Documento"
            rules="required"
          >
            <span class="file-upload__label">Archivo:</span>
            <custom-file-input
              v-model="model.file"
              accept=".pdf"
              custom-error-msg="El documento es requerido."
              display-style="normal"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div v-if="isProvisionalRemedyArea" class="col col-sm-2 d-flex">
          <check-box
            v-model="model.canAddEvaluator"
            class="align-self-center mt-3"
            text="Añadir Evaluador"
          />
        </div>
        <div v-if="model.canAddEvaluator" class="col col-sm-4">
          <span class="file-upload__label">Nombre del Evaluador:</span>
          <validation-provider
            v-slot="{ errors }"
            class="w-100"
            rules="required"
          >
            <custom-input
              v-model="model.evaluatorName"
              custom-error-msg="El nombre del evaluador es requerido."
              :error="errors[0]"
              maxlength="50"
            />
          </validation-provider>
        </div>
        <div
          v-if="!model.canAddEvaluator"
          class="col col-sm-4 d-flex align-items-end justify-content-end"
        >
          <div>
            <action-button
              class="action-button"
              i="fas fa-times-circle"
              variant="outline-danger"
              @click="cancel"
            >
              Cancelar
            </action-button>
            <action-button
              class="action-button"
              :i="id ? 'fas fa-save' : 'fas fa-file-plus'"
              variant="success"
              @click="passes(upload)"
            >
              {{ id ? 'Guardar' : 'Añadir' }}
            </action-button>
          </div>
        </div>
      </div>

      <div v-if="model.canAddEvaluator" class="row mt-4">
        <div class="col d-flex align-items-end justify-content-end">
          <div>
            <action-button
              class="action-button"
              i="fas fa-times-circle"
              variant="outline-danger"
              @click="cancel"
            >
              Cancelar
            </action-button>
            <action-button
              class="action-button"
              :i="id ? 'fas fa-save' : 'fas fa-file-plus'"
              variant="success"
              @click="passes(upload)"
            >
              {{ id ? 'Guardar' : 'Añadir' }}
            </action-button>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import CheckBox from 'CheckBox';
import CustomFileInput from '@/components/common/CustomFileInput';
import CustomInput from '@/components/common/form/CustomInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'DeterminationFileUpload',
  components: {
    CheckBox,
    CustomFileInput,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    evaluatorName: {
      type: String,
      default: '',
    },
    isProvisionalRemedyArea: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        id: this.id,
        name: this.name,
        file: null,
        canAddEvaluator: !!this.evaluatorName,
        evaluatorName: this.evaluatorName,
      },
    };
  },
  watch: {
    'model.canAddEvaluator'(newVal) {
      if (!newVal) {
        this.model.evaluatorName = null;
      }
    },
  },
  methods: {
    clear() {
      this.model = {
        id: null,
        name: null,
        canAddEvaluator: false,
        evaluatorName: null,
        file: null,
      };
    },
    cancel() {
      this.$emit('cancel');
      this.clear();
    },
    upload() {
      const payload = {
        id: this.model.id,
        name: this.model.name,
        evaluatorName: this.model.evaluatorName,
        file: this.model.file,
      };
      this.$emit('upload', payload);
      this.clear();
    },
  },
};
</script>
<style>
.file-upload__container {
  background-color: #f7f7f7;
  border-radius: 2px;
  padding: 15px;
  margin-bottom: 10px;
}
.file-upload__label {
  font-size: 14px;
  color: gray;
}
.action-icon {
  padding: 0 !important;
  margin: 0 !important;
}
.action-button {
  margin: 0 5px;
}
</style>
